import { Button, Col, Collapse, Form, Input, Row } from "antd";
import { BiRightArrowAlt } from "react-icons/bi";
import { useContext } from "react";
import { Link, useNavigate } from "react-router-dom";
import { AuthModalContext } from "../../Contexts/AuthModalContext";
import BreadCrumb from "../../Components/BreadCrumb/BreadCrumb";
import Layout from "../../Components/Layout/Layout";
import styles from "./PublicOrderTrack.module.scss";
import { DownOutlined } from "@ant-design/icons";
import { faqQuestions } from "./data";

const PublicOrderTrack = () => {
    const navigate = useNavigate();
    const { openSignIn } = useContext(AuthModalContext);

    const submitHandler = ({ id }) => {
        console.log(id);
        navigate(`/track-order/${id}`);
    };

    return (
        <Layout title="Track order">
            <div className={`container`}>
                <div>
                    <Row>
                        <Col xs={24} lg={0}>
                            <BreadCrumb
                                list={[
                                    { name: "Home", link: "/" },
                                    { name: "Track your order", link: "/track-order" },
                                ]}
                            />
                        </Col>
                        <Col xs={0} lg={24} style={{ marginTop: 10 }}>
                            <BreadCrumb
                                list={[
                                    { name: "Back to Home", link: "/" },
                                    { name: "Track your order", link: "/track-order" },
                                ]}
                            />
                        </Col>
                    </Row>

                    <div className={styles.track_order_container}>
                        <div className={styles.truck}>
                            <img src="https://desi-fresh.b-cdn.net/components_static/Orders/truck.svg" alt="truck" />
                            <p>Track your order</p>
                        </div>

                        <Form
                            name="signin"
                            onFinish={submitHandler}
                            scrollToFirstError
                            layout="vertical"
                            requiredMark={false}
                            labelCol={{
                                style: {
                                    fontWeight: 600,
                                },
                            }}
                            style={{ width: "100%" }}
                        >
                            <Form.Item
                                name="id"
                                label="Order number (13 digits required)"
                                extra={
                                    <p
                                        style={{
                                            marginTop: "8px",
                                            color: "#000",
                                            marginBottom: 0,
                                            textAlign: "center",
                                        }}
                                    >
                                        Here, you'll find everything you need to know about your shipments.
                                    </p>
                                }
                                rules={[
                                    {
                                        required: true,
                                        message: "Please enter your order ID!",
                                    },
                                ]}
                            >
                                <Input size="large" placeholder="DF28276854" />
                            </Form.Item>

                            <Form.Item className={styles.submit_btn}>
                                <Button size="large" type="primary" htmlType="submit">
                                    <span>Track Order</span>
                                    <img
                                        src="https://desi-fresh.b-cdn.net/components_static/Orders/map.svg"
                                        alt="map"
                                        className={styles.map}
                                    />
                                </Button>
                            </Form.Item>
                        </Form>

                        <div className={styles.sign_in}>
                            <div>Already have an account?</div>{" "}
                            <span role="button" style={{ cursor: "pointer", textDecoration: "underline" }} onClick={() => openSignIn()}>
                                Sign in
                            </span>
                        </div>
                        <div className={styles.pri_pol}>
                            <div>See our</div> <Link to={"/data-protection"}>Privacy policy</Link>
                        </div>

                        <div className={styles.delivery_partners}>
                            <h2>Delivery Partners</h2>
                            <Row gutter={[20, 20]}>
                                {/* <Col span={24}>
                                    <div className={styles.partner}>
                                        <img src="https://desi-fresh.b-cdn.net/components_static/Orders/ups_logo.svg" alt="ups" />

                                        <Button type={"primary"} size={"large"} className={styles.send_btn}>
                                            Track now with sending Nr.
                                            <BiRightArrowAlt size={25} color={"#fff"} />
                                        </Button>
                                    </div>
                                </Col> */}
                                {/* <Col span={24}>
                                    <div className={styles.partner}>
                                        <img src="https://desi-fresh.b-cdn.net/components_static/Orders/hermes_logo.svg" alt="ups" />

                                        <Button type={"primary"} size={"large"} className={styles.send_btn}>
                                            Track now with sending Nr.
                                            <BiRightArrowAlt size={25} color={"#fff"} />
                                        </Button>
                                    </div>
                                </Col>{" "} */}
                                {/* <Col span={24}>
                                    <div className={styles.partner}>
                                        <img src="https://desi-fresh.b-cdn.net/components_static/Orders/dhl_logo.svg" alt="ups" />

                                        <Button type={"primary"} size={"large"} className={styles.send_btn}>
                                            Track now with sending Nr.
                                            <BiRightArrowAlt size={25} color={"#fff"} />
                                        </Button>
                                    </div>
                                </Col> */}
                                <Col span={24}>
                                    <div className={styles.partner}>
                                        <img src="https://desi-fresh.b-cdn.net/components_static/Orders/DPD_Logo.svg" alt="ups" />

                                        <Button type={"primary"} size={"large"} className={styles.send_btn}>
                                            Track now with sending Nr.
                                            <BiRightArrowAlt size={25} color={"#fff"} />
                                        </Button>
                                    </div>
                                </Col>
                            </Row>
                        </div>

                        <div className={styles.delivery_faq}>
                            <div className={styles.faq_top}>
                                <img src="https://desi-fresh.b-cdn.net/components_static/Orders/faq_icon.svg" alt="icon" />
                                <h2>Delivery (FAQ)</h2>
                            </div>
                            <div className={styles.helper_text}>
                                Here are the answers to your most common questions. Can’t find the answer? Message us your question via{" "}
                                <Link to="/contact-us">Contact us</Link>
                            </div>

                            <Row>
                                <div className={styles.questions}>
                                    <Collapse
                                        accordion={true}
                                        ghost={true}
                                        expandIcon={({ isActive }) => <DownOutlined size={20} rotate={isActive ? 180 : 0} />}
                                        bordered={false}
                                        expandIconPosition="end"
                                    >
                                        {faqQuestions.map((item) => (
                                            <Collapse.Panel header={<span style={{ marginLeft: 5 }}> {item.question} </span>} key={item.id}>
                                                <span>{item.answer}</span>
                                            </Collapse.Panel>
                                        ))}
                                    </Collapse>
                                </div>
                            </Row>
                        </div>
                    </div>
                </div>
            </div>
        </Layout>
    );
};

export default PublicOrderTrack;
